module.exports = __webpack_public_path__ + "img/no-comments.cff18eeb.png";